const shopify = {
  inputCardExpiryDate: 'Fecha de Vencimiento',
  inputCardSecurityCode: 'Código de Seguridad',
};


module.exports = shopify;
